import { render } from "./Badges.vue?vue&type=template&id=561039d2&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import "./Badges.vue?vue&type=style&index=0&id=561039d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561039d2"]])

export default __exports__